import _ from 'lodash'

// next-intl allows only alphanumeric chars and underscore as interpolation variables names, so:
// e.g. "{{registration-count}}" is not allowed and must be amended to "{{registration_count}}" internally

export const sanitizeKeyOfValues = (key: string) => key.replace(/\W/g, '_')

export const sanitizeKeysOfValues = (values: Record<string, any>): Record<string, any> =>
  _.mapKeys(values, (_value, key) => sanitizeKeyOfValues(key))
